package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.projects.ProjectsScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_sr_projects
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteProjects : RouteParameterTo

object RouterProjects : RouterNoParameters<RouteProjects>(RouteProjects::class) {
    override fun routeFrom(parameters: RouteProjects) = "/projects"

    @Composable
    override fun Show(parameters: RouteProjects) {
        RouteProjectsImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteProjects,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteProjects

    override fun isMatching(route: String) = route == "/projects"

    override fun navigateFrom(path: String) = RouteProjects
}

class RouteProjectsImpl : Route<RouteProjects>(
    route = "/projects",
    params = RouteProjects,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.menu_sr_projects,
                    listOf(
                        MenuItem.MenuItemSimple(
                            imageVector = Icons.Rounded.Logout,
                            onClick = { appModel.logout() }
                        )
                    )
                )
            )
        }

        ProjectsScreen()
    }
}
